import { render, staticRenderFns } from "./UberMenuViewer.vue?vue&type=template&id=8b9247fa"
import script from "./UberMenuViewer.vue?vue&type=script&lang=js"
export * from "./UberMenuViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports